import { render, staticRenderFns } from "./CardStages.vue?vue&type=template&id=043c957e"
import script from "./CardStages.vue?vue&type=script&lang=js"
export * from "./CardStages.vue?vue&type=script&lang=js"
import style0 from "./CardStages.vue?vue&type=style&index=0&id=043c957e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports